// Must stay the first import: errors thrown before init() are not captured.
import "./appsignal";

require("@rails/ujs").start()

// Entry point for the build script in your package.json
import "./controllers"